import React from 'react';
import { MdReportProblem, MdGavel } from 'react-icons/md';

function JournalistProblems() {
  const problems = [
    "Troubled Tamil media journalists.",
    "Media journalists who are getting scattered like refugees.",
    "Media journalists who are suiciding because of poverty.",
    "Government privileges that are refused to media journalists.",
    "Brutes who murder media journalists.",
    "Blaming the media unnecessarily.",
    "The atrocious people who are disrespecting the media.",
    "The face of terrorism! The pitiable media journalists breed.",
    "Sexual misbehaviors and rapes on female journalists.",
    "Sinners who burn the press offices.",
    "The people in the government who crush the journalists to come to power.",
    "The attacks on media journalists by rowdies and murders of media journalists.",
    "The sad state of media journalists being bought with money, we can go on and on listing the many offences."
  ];

  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl flex items-center justify-center">
             <MdReportProblem className="mr-3 text-red-600" />
            Problems of Media Journalists
          </h1>
          <p className="mt-4 text-xl text-gray-500">
            Challenges Faced by Our Reporters
          </p>
        </div>

        <div className="bg-white shadow-lg rounded-lg overflow-hidden mb-10">
            {/* Banner Image */}
            <div className="w-full h-64 bg-gray-200 flex items-center justify-center text-gray-500">
                <img 
                    src="https://images.unsplash.com/photo-1504711434969-e33886168f5c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" 
                    alt="Journalist Problems" 
                    className="w-full h-full object-cover" 
                />
            </div>
            <div className="p-8">
                <ul className="space-y-4">
                    {problems.map((problem, index) => (
                        <li key={index} className="flex items-start">
                             <div className="flex-shrink-0 h-6 w-6 rounded-full bg-red-100 flex items-center justify-center mt-1">
                                <span className="text-red-600 font-bold text-sm">{index + 1}</span>
                             </div>
                             <p className="ml-4 text-lg text-gray-700 leading-relaxed">
                                {problem}
                             </p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>

        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
            <div className="bg-blue-600 px-8 py-4">
                <h2 className="text-2xl font-bold text-white flex items-center">
                    <MdGavel className="mr-3" />
                    NAI Code of Ethics
                </h2>
            </div>
            <div className="p-8">
                <ul className="space-y-4">
                    {[
                        { title: "Principles of Reporting", link: "#" },
                        { title: "Research", link: "#" },
                        { title: "Freedom of the Press", link: "#" },
                        { title: "Independence of Reporting", link: "#" },
                        { title: "Code of Ethics", link: "#" },
                        { title: "Criteria & Rules and Regulations", link: "#" }
                    ].map((item, index) => (
                        <li key={index} className="flex items-center">
                            <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                            <a href={item.link} className="text-lg text-gray-700 hover:text-blue-600 hover:underline transition-colors">
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>

      </div>
    </div>
  );
}

export default JournalistProblems;
